import { ALL_TEXT_TEMPLATES_PAID_ONLY } from '@/constants/common';

/**
 * Whether a text template counts as paid-only: its own `onlyForPaidPlans`
 * flag, or every template while the ALL_TEXT_TEMPLATES_PAID_ONLY experiment
 * is on (unless the preset opts out with `onlyForPaidPlans: false`).
 */
export function isPaidOnlyPreset(
  preset?: { onlyForPaidPlans?: boolean } | null,
): boolean {
  if (!preset) return false;
  if (preset.onlyForPaidPlans) return true;
  return ALL_TEXT_TEMPLATES_PAID_ONLY && preset.onlyForPaidPlans !== false;
}
